import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from './Button';

export default function SaveButton({ onClick, className = '' }) {
  const { t } = useTranslation();
  return (
    <Button level="dark" size="sm" className={className} onClick={onClick}>
      {t('common.save')}
    </Button>
  );
}
